// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.CustomReminderPopup__popup-dc8f17 {
  max-height: 230px;
}

.CustomReminderPopup__form-fc32d1 {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding: 24px;
  gap: 24px;
}

.CustomReminderPopup__container-ff78f3 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.CustomReminderPopup__count-field-a2c63f {
  width: 60px;
}

/* 1. Для Chrome, Safari, Edge, Opera */
.CustomReminderPopup__count-field-a2c63f input[type=number]::-webkit-outer-spin-button,
.CustomReminderPopup__count-field-a2c63f input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 2. Для Firefox */
.CustomReminderPopup__count-field-a2c63f input[type=number] {
  -moz-appearance: textfield;
}

.CustomReminderPopup__unit-field-b9ad28 {
  width: 126px;
}

.CustomReminderPopup__type-field-b58e55 {
  width: 100%;
}

.CustomReminderPopup__same-day-field-f5b0bc {
  margin-bottom: 8px;
}

.CustomReminderPopup__text-d23551 {
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-inline-end: auto;
}

.CustomReminderPopup__filters-a8ec62 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/Popup/CustomReminderPopup/CustomReminderPopup.styles.m.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA,uCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAEF;;AACA,mBAAA;AACA;EACE,0BAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAEF","sourcesContent":[".popup {\n  max-height: 230px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n  gap: 24px;\n}\n\n.container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.count-field {\n  width: 60px;\n}\n\n/* 1. Для Chrome, Safari, Edge, Opera */\n.count-field input[type='number']::-webkit-outer-spin-button,\n.count-field input[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* 2. Для Firefox */\n.count-field input[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.unit-field {\n  width: 126px;\n}\n\n.type-field {\n  width: 100%;\n}\n\n.same-day-field {\n  margin-bottom: 8px;\n}\n\n.text {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-inline-end: auto;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `CustomReminderPopup__popup-dc8f17`,
	"form": `CustomReminderPopup__form-fc32d1`,
	"container": `CustomReminderPopup__container-ff78f3`,
	"count-field": `CustomReminderPopup__count-field-a2c63f`,
	"countField": `CustomReminderPopup__count-field-a2c63f`,
	"unit-field": `CustomReminderPopup__unit-field-b9ad28`,
	"unitField": `CustomReminderPopup__unit-field-b9ad28`,
	"type-field": `CustomReminderPopup__type-field-b58e55`,
	"typeField": `CustomReminderPopup__type-field-b58e55`,
	"same-day-field": `CustomReminderPopup__same-day-field-f5b0bc`,
	"sameDayField": `CustomReminderPopup__same-day-field-f5b0bc`,
	"text": `CustomReminderPopup__text-d23551`,
	"filters": `CustomReminderPopup__filters-a8ec62`
};
module.exports = ___CSS_LOADER_EXPORT___;
